import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { NotificationService } from "src/app/core/notification.service";
import { PicketService } from "src/app/core/picket.service";
import { ApiResponse } from "src/app/shared/interfaces/api-response";
import { MemberDetails } from "src/app/shared/interfaces/member-details";
import {
    PicketRecordDetails,
    SignedInOutMemberDetails,
} from "src/app/shared/interfaces/picket-member-details";

@Component({
  selector: "app-picket-sign-in",
  templateUrl: "./picket-sign-in.component.html",
  styleUrls: ["./picket-sign-in.component.css"],
})
export class PicketSignInComponent implements OnInit {
  strikeId = "";
  picketId = "";
  picketName = "";
  currentTime: Date = new Date();
  filterMember = "";
  member: MemberDetails = { MemberId: "" };
  lastSignedInMembers: SignedInOutMemberDetails[] = [];
  lastSignedInMember: SignedInOutMemberDetails = { MemberId: "" };
  displayExistingSignInMessage = false;
  alreadyExistingMessage = "";
  existingSignIn: PicketRecordDetails = { MemberId: "" };
  newPicketSignIn: PicketRecordDetails = { MemberId: "" };
  slNo = 0;

  constructor(
    private route: ActivatedRoute,
    private picket: PicketService,
    private notificationService: NotificationService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.strikeId = String(this.route.snapshot.paramMap.get("id"));
    this.picketId = String(this.route.snapshot.paramMap.get("picket"));
    this.picketName = String(this.route.snapshot.paramMap.get("name"));
    this.getTime();
  }

  getTime() {
    setInterval (() => {
      this.currentTime = new Date();
    }, 1000)
  }

  async searchMbr() {
    const response = await this.picket.getPicketMemberInfo(
      this.strikeId,
      this.filterMember,
    );

    if (response.success) {
      this.searchMbrSuccess(response);
    } else {
      this.searchMbrFail(response);
    }
  }

  async searchMbrSuccess(response: ApiResponse) {
    this.member = response.body;

    // Uses ID rather than memberId
    const lastSignInResponse = await this.picket.getLatestSignIn(
      this.strikeId,
      String(this.member.ID),
    );

    if (lastSignInResponse.success) {
      this.loadSignInPicketSuccess(lastSignInResponse);
    } else {
      this.loadSignInPicketFail();
    }
  }

  searchMbrFail(response: ApiResponse) {
    this.member = { MemberId: "" };

    if (response.statusCode == 400) {
      this.notificationService.displayError(response.body);
    }
    else {
      this.notificationService.displayError(response.errorMessage);
    }

  }

  loadSignInPicketSuccess(response: ApiResponse) {
    this.existingSignIn = response.body;
    this.displayExistingSignInMessage = true;

    this.alreadyExistingMessage =
      this.existingSignIn.MemberId +
      "  " +
      this.existingSignIn.FirstName +
      "  " +
      this.existingSignIn.MiddleName +
      "  " +
      this.existingSignIn.LastName +
      "  " +
      this.datePipe.transform(this.existingSignIn.SignInTime, "M/d/yyyy") +
      "  @  " +
      this.existingSignIn.SignInHour +
      ":" +
      this.existingSignIn.SignInMinute;
  }

  loadSignInPicketFail() {
    this.existingSignIn = { MemberId: "" };
    this.displayExistingSignInMessage = false;
  }

  clearSearchMbr() {
    this.filterMember = "";
  }

  async addSignInPicketline() {
    this.newPicketSignIn.FirstName = this.member.FirstName;
    this.newPicketSignIn.LastName = this.member.LastName;
    this.newPicketSignIn.MemberId = this.member.MemberId;
    this.newPicketSignIn.MiddleName = this.member.MiddleName;
    this.newPicketSignIn.SignInLocalTime = String(this.datePipe.transform(this.currentTime, "MM/dd/yyyy HH:mm"));
    this.newPicketSignIn.SignInMethod = "ID Card Scanned";
    this.newPicketSignIn.SignInTime = this.currentTime;
    this.newPicketSignIn.StrikeInfoId = this.strikeId;
    this.newPicketSignIn.StrikeMemberId = this.member.ID;
    this.newPicketSignIn.StrikePicketlineId = this.picketId;
    this.newPicketSignIn.WalkDate = this.currentTime;

    const response = await this.picket.addSignIn(this.newPicketSignIn);

    if (response.success) {
      this.addedSuccess();
    } else {
      this.addedFail(response);
    }
  }

  addedSuccess() {
    this.notificationService.displaySuccess("Sign-in recorded successfully!");
    this.slNo += 1;

    this.lastSignedInMember.FirstName = this.newPicketSignIn.FirstName;
    this.lastSignedInMember.LastName = this.newPicketSignIn.LastName;
    this.lastSignedInMember.MemberId = this.newPicketSignIn.MemberId;
    this.lastSignedInMember.MiddleName = this.newPicketSignIn.MiddleName;
    this.lastSignedInMember.SignIn = this.newPicketSignIn.SignInTime;
    this.lastSignedInMember.SlNo = this.slNo;

    this.lastSignedInMembers.push(this.lastSignedInMember);
    this.lastSignedInMember = { MemberId: "" };
    this.existingSignIn = { MemberId: "" };
    this.member = { MemberId: "" };
    this.filterMember = "";
  }

  addedFail(response: ApiResponse) {
    this.existingSignIn = response.body;
    this.notificationService.displayError(response.errorMessage);
    this.notificationService.displaySuccess("Already signed-in!");
  }
}
